import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../config/api-endpoints';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class IS4UPSService {
   constructor(
        private http: HttpClient
    ) { }

    public uploadDocument(file: FormData): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.IS4UPS_DOCUMENT_UPLOAD}`, file);
    }
}
